// @ts-nocheck
/* eslint-disable */
import BusyLoader from './BusyLoader';
import { CommonUtil } from "../utils/CommonUtil";
import Confirm from "./confirm";

export class NetworkManager {
  static serverPath: string = '';

  /**
   * Sends a JSON request to the server.
   * @param address - The endpoint address
   * @param jsonData - The JSON body data (pass '' for no body)
   * @param qParam - Query parameters as a string
   * @param method - HTTP method (GET, POST, etc.)
   * @param busy - Whether to show the busy loader
   * @param successCallBack - Callback for successful response (returns string)
   * @param errorCallBack - Callback for errors
   */
  static async sendJsonRequest(
    address: string,
    jsonData: any,
    qParam: string,
    method: string,
    busy: boolean,
    successCallBack: any,
    errorCallBack: any,
    retryCount: number = 0
  ) {
    let serverUrl = this.serverPath + address;
    if (qParam) {
      serverUrl += `?${qParam}`;
    }

    if (busy) {
      BusyLoader.showLoader();
    }

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const token = localStorage.getItem('token');
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);
    }

    const requestOptions: RequestInit = {
      method,
      headers,
    };

    if (jsonData !== '') {
      requestOptions.body = JSON.stringify(jsonData);
    }

    try {
      const response = await fetch(serverUrl, requestOptions);

      // Handle successful but possibly non-JSON responses
      let result: any;
      if (response.ok) {
        result = await response.text();
      } else {
        // Errors usually return JSON with error details
        try {
          result = await response.json();
        } catch (e) {
          result = await response.text();
        }
      }

      if (busy) {
        BusyLoader.hideLoader();
      }

      if (typeof result === 'string') {
        successCallBack(result);
        return;
      }

      // Handle token expiration errors
      if (result && typeof result === 'object') {
        if (result.errorCode === "TOKEN_EXPIRED") {
          if (retryCount < 3) {
            await this.handleTokenExpired(address, jsonData, qParam, method, busy, successCallBack, errorCallBack, retryCount + 1);
          } else {
            CommonUtil.onLogout();
          }
          return;
        }

        if (result.errorMessage === "EXPIRED_REFRESH_TOKEN") {
          Confirm.show("Info", "Refresh Token Expired. Please login again.", [
            {
              label: 'OK',
              callback: () => CommonUtil.onLogout(),
            },
          ]);
          return;
        }

        // Return object as string for compatibility with existing callers
        successCallBack(JSON.stringify(result));
      }
    } catch (error) {
      console.error('Network Error:', error);
      if (busy) {
        BusyLoader.hideLoader();
      }
      errorCallBack(error);
    }
  }

  /**
   * Internal helper to handle token expiration and retry the original request.
   */
  private static async handleTokenExpired(
    address: string,
    jsonData: any,
    qParam: string,
    method: string,
    busy: boolean,
    successCallBack: any,
    errorCallBack: any,
    retryCount: number
  ) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      CommonUtil.onLogout();
      return;
    }

    const refreshTokenAPI = 'api/auth/refreshToken';
    const req = { refreshToken };

    await this.sendJsonRequest(
      refreshTokenAPI, req, '', 'POST', true,
      (dataObj: any) => {
        const restData = CommonUtil.parseData(dataObj);
        if (restData && restData.token) {
          localStorage.setItem('token', restData.token);
          // Retry the original request
          this.sendJsonRequest(address, jsonData, qParam, method, busy, successCallBack, errorCallBack, retryCount);
        } else {
          CommonUtil.onLogout();
        }
      },
      () => CommonUtil.onLogout(),
      retryCount
    );
  }
}

